import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ThemeContext } from '../ThemeContext';
import GameYourSatLogo from '../img/GameYourSatLogo.png';

const Footer = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { path: '/about-mety-technology', label: 'About METY Technology' },
    { path: '/contact-us', label: 'Contact Us' },
    { path: '/terms', label: 'Terms and Conditions' },
    { path: '/privacy', label: 'Privacy Policy' },
  ];

  const handleLinkClick = (path, e) => {
    e.preventDefault();
    // Navigate to the page - pages will be created later
    navigate(path);
  };

  return (
    <footer 
      className={`w-full border-t ${
        isDarkMode 
          ? 'border-gray-700 bg-gray-900/80' 
          : 'border-gray-200 bg-white/95'
      } backdrop-blur-sm mt-auto relative z-10`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-start gap-6 md:gap-8">
          {/* Left Section - Logo, Tagline, Copyright */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex flex-col gap-3 md:gap-4 w-full md:w-auto"
          >
            {/* Logo */}
            <motion.div
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
              className="flex items-start"
            >
              <img
                src={GameYourSatLogo}
                alt="GameYourSAT Logo"
                className="h-10 md:h-12 w-auto object-contain cursor-pointer"
                onClick={() => navigate('/')}
                draggable={false}
              />
            </motion.div>

            {/* Tagline */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className={`text-base md:text-lg font-bold font-zonaProUltra ${
                isDarkMode ? 'text-gray-200' : 'text-gray-900'
              }`}
            >
              Game Your SAT: Level Up Your SAT Score.
            </motion.p>

            {/* Copyright */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className={`text-xs md:text-sm font-zonaProRegular ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}
            >
              © {currentYear} METY Technology, Inc. All Rights Reserved.
            </motion.p>
          </motion.div>

          {/* Right Section - Navigation Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="flex flex-col gap-2 md:gap-3"
          >
            {footerLinks.map((link, index) => (
              <motion.div
                key={link.path}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 + index * 0.1, duration: 0.4 }}
                whileHover={{ x: 5 }}
              >
                <Link
                  to={link.path}
                  onClick={(e) => handleLinkClick(link.path, e)}
                  className={`text-left text-sm md:text-base font-bold font-zonaProUltra transition-colors duration-200 block hover:opacity-80 ${
                    isDarkMode 
                      ? 'text-gray-200 hover:text-[#06bae4]' 
                      : 'text-gray-900 hover:text-[#06bae4]'
                  }`}
                >
                  {link.label}
                </Link>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
